import { observer } from "mobx-react-lite";
import SmartAppBase from "../../components/apps/SmartAppBase";
import { analysisAndOcrApp } from "../../services/apps/SmartApps";
import { FileUpload } from "@mui/icons-material";
import ExportButton from "../../components/buttons/app-action-buttons/ExportButton";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";
import SmartAppStep from "../../components/apps/SmartAppStep";
import VideoAnalysisDiagramSection from "../video-analysis/components/VideoAnalysisDiagramSection";
import Player from "../../components/video-player/Player";
import VideoPlayer from "e.sic-platform.webclient/src/components/video-player/VideoPlayer";
import { Grid } from "@mui/material";
import OcrInput from "../ocr-service/components/OcrInput";
import RunOcrServiceButton from "../../components/buttons/run-ocr-service-button/RunOcrServiceButton";
import { useCallback } from "react";

export default observer (function AnalysisAndOcrPage() {
    const videoAnalysisService = analysisAndOcrApp.services.videoAnalysis!
    const ocrService = analysisAndOcrApp.services.ocrService!;
    const { themeClass } = useThemeService();

    const startOcr = useCallback(async () => {
      await ocrService.startService();
      await ocrService.load();
    }, [ocrService])

    if (videoAnalysisService.analysisSuccessful) analysisAndOcrApp.setStep(3);

    return (
      <SmartAppBase 
        appStorage={analysisAndOcrApp}
        icon={{
          svg: FileUpload,
          textKey: "RunAnalysisAndSegmentation.run",
          className: themeClass(["icon-custom"]),
        }}
        actionBar={<ExportButton exportVideoAnalaysis={videoAnalysisService.exportVideoAnalysis} disabled={!videoAnalysisService.analysisSuccessful || videoAnalysisService.isLoading}/>}
      >
        <SmartAppStep
          titleKey="videoAnalysis.viewVideo.title"
          descriptionKey="videoAnalysis.viewVideo.description"
          visible={videoAnalysisService.video !== undefined}
          step={2}
          appStorage={analysisAndOcrApp}
        >
          <Grid container rowSpacing={1}>
            <Grid item xs={12} sm={12} xl={8}>
             {ocrService.video !== undefined && (
             <Player service={ocrService}>
              {ocrService?.video!.isAvailable && <VideoPlayer enableControls />}
             </Player>            
            )}
            </Grid>
          <Grid container xs={12} sm={12} xl={8} sx={{mt: 1}}>
            <OcrInput ocrService={ocrService}/>
          </Grid>
          <Grid item xs={12} sm={12} xl={8} className="centered">
            <RunOcrServiceButton
              onClick={startOcr}
              disabled={!ocrService.inputProvided}
            />
          </Grid>
        </Grid>
      </SmartAppStep>
      <SmartAppStep
        titleKey="videoAnalysis.analysis.title"
        descriptionKey="videoAnalysis.analysis.description"
        visible={
          videoAnalysisService.video !== undefined &&
          videoAnalysisService.video.isConverted
        }
        step={3}
        appStorage={analysisAndOcrApp}
      > 
      <VideoAnalysisDiagramSection videoAnalysis={videoAnalysisService} />
      </SmartAppStep>
      </SmartAppBase>
    )
    
});



